import axios from "axios";
import { Link, useParams } from "react-router-dom";
import apiUrl from "../../environment/Api";
import { useEffect, useState } from "react";

function JobMemberDetail() {
  const [member, setMember] = useState([]);

  const { id } = useParams();

  const fetchData = async () => {
    try {
      const response = await axios.get(apiUrl + `/application/${id}`);
      console.log("Response from server:", response.data);
      setMember(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const getFileExtension = (filePath) => {
    return filePath.split('.').pop().toLowerCase();
  };

  const renderFilePreview = (filePath) => {
    const fileExtension = getFileExtension(filePath);
    if (fileExtension === 'pdf') {
      // For PDF preview, you can use a library like react-pdf or render it in an iframe
      return (
        <div>
          <embed
            src={filePath}
            type="application/pdf"
            width="100%"
            height="150px"
          />
        </div>
      );
    } else {
      return <span>{filePath}</span>;
    }
  };


  return (
    <>
      <div className="marginup">
        {/* Breadcrumbs */}
        <div className="row">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link
              to="/Jobportal"
              className="text-secondary dashBoard_text"
            >
              <b>Job Portal / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>Profile</b>
            </Link>
          </div>
        </div>

        <h5>
          <b>Job Memeber Details</b>
        </h5>
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-12 col-md-9 col-sm-12">
          <h3 className="">Personal Details</h3>
          <div className="card p-3">
            <div className="row">
              <div className="col-lg-6">
                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Full Name</h6>
                  <b>{member[0]?.name || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Contact Number</h6>

                  <b>{member[0]?.contact_number || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Date Of Birth</h6>

                  <b>{member[0]?.dateofbirth || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Current Address</h6>

                  <b>{member[0]?.current_address || ""}</b>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Email</h6>

                  <b>{member[0]?.email_address || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Position</h6>

                  <b>{member[0]?.designation || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Source Type</h6>

                  <b>{member[0]?.select_source || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Permanent Address</h6>

                  <b>{member[0]?.permanent_address || ""}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-9 col-md-9 col-sm-12">
          <h3 className="">Education Details</h3>
          <div className="card p-3">
            <div className="row">
              <div className="col-lg-6">
                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Highest Qualification</h6>
                  <b>{member[0]?.higher_qualification || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    University/Institution Name
                  </h6>

                  <b>{member[0]?.university || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Field Of Study</h6>

                  <b>{member[0]?.field_of_study || ""}</b>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Year Of Graduation</h6>

                  <b>{member[0]?.year_of_gradution || ""}</b>
                </div>

                <div className="row">
                  <h6 className="text-secondary m-0">Experience Level</h6>

                  <b>{member[0]?.experienceLevel || ""}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <h6 className="text-secondary m-0 mb-2">Additional Certificate:</h6>
          <div
            className="card p-3"
            style={{ width: '100%', height: '240px', overflow: 'hidden' }}
          >

            {member && member[0] && member[0].additional_certification
              ? renderFilePreview(member && member[0] && member[0].additional_certification)
              : <span>No certificate available</span>}
            <b>{member && member[0] && member[0].additional_certification || ""}</b>
          </div>

        </div>
      </div>

      <div className="container text-center">
        <h4 className="text-warning" style={{ textDecoration: 'underline' }}>Fresher</h4>
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-12 col-md-12 col-sm-6">
          <h3 className="">Skills & Competition</h3>
          <div className="card p-3">
            <div className="row mb-4">
              <h6 className="text-secondary m-0">Technical Skills</h6>
              <b>{member[0]?.techical_skills.join(", ") || ""}</b>

            </div>

            <div className="row mb-4">
              <h6 className="text-secondary m-0">Language</h6>

              <b>{member[0]?.language.join(", ") || ""}</b>

            </div>

            <div className="row mb-4">
              <h6 className="text-secondary m-0">Relevant Soft Skills</h6>

              <b>{member[0]?.relevant_of_skills.join(", ") || ""}</b>

            </div>
          </div>
        </div>
      </div>

      <div className="container text-center">
        <h4 className="text-warning" style={{ textDecoration: 'underline' }}>Experience</h4>
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-12 col-md-9 col-sm-12">
          <h3 className="">Experience Details</h3>
          <div className="card p-3">
            <div className="row">
              <div className="col-lg-6">
                <h3 className="mb-3">Experience 1</h3>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Organization</h6>
                  <b>{member[0]?.select_experience_year || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Date of Joining</h6>

                  <b>{member[0]?.date_of_joining_one || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Date of Relieving</h6>

                  <b>{member && member[0] && member[0].date_of_relieving_one || ""}</b>

                </div>



                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Designation</h6>

                  <b>{member && member[0] && member[0].designation_one || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Experience/Relieving Letter
                  </h6>

                  <b>{member && member[0] && member[0].experience_letter_one || ""}</b>


                </div>




                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Take Home
                  </h6>

                  <b>{member[0]?.take_home_one || ""}</b>

                </div>




                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Expected Salary
                  </h6>

                  <b>{member[0]?.expected_salary_one || ""}</b>

                </div>
              </div>

              <div className="col-lg-6">
                <h3 className="mb-3">Experience 2</h3>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Organization</h6>

                  <b>{member && member[0] && member[0].organization_name_two || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Date of Joining</h6>



                  <b>{member && member[0] && member[0].date_of_joining_two || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Date of Relieving:</h6>

                  {/* <b>{member[0].name || ""}</b> */}
                  <b>{member && member[0] && member[0].date_of_relieving_two || ""}</b>
                </div>



                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Designation</h6>

                  <b>{member && member[0] && member[0].designation_two || ""}</b>

                </div>


                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Take Home
                  </h6>

                  <b>{member[0]?.take_home_two || ""}</b>

                </div>




                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Expected Salary
                  </h6>

                  <b>{member[0]?.expected_salary_two || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">
                    Experience/Relieving Letter
                  </h6>
                  <b>{member && member[0] && member[0].experience_letter_two || ""}</b>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>


      <div className="container text-center">
        <h4 className="text-warning" style={{ textDecoration: 'underline' }}>Reference</h4>
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-12 col-md-9 col-sm-12">
          <h3 className="">Reference Details</h3>
          <div className="card p-3">
            <div className="row">
              <div className="col-lg-6">
                <h3 className="mb-3">Reference 1</h3>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Name</h6>
                  {/* <b>{member[0].name || ""}</b> */}
                  <b>{member[0]?.reference_name_one || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Position</h6>
                  <b>{member[0]?.reference_position_one || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Contact Number</h6>
                  <b>{member && member[0] && member[0].reference_phonenumber_one || ""}</b>

                  {/* <b>{member[0].reference_phonenumber_one || ""}</b> */}
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Email Address</h6>
                  <b>{member && member[0] && member[0].reference_email_one || ""}</b>

                  {/* <b>{member[0].reference_email_one || ""}</b> */}
                </div>


                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Additional Information</h6>

                  <b>{member && member[0] && member[0].additional_information || ""}</b>

                </div>

              </div>




              <div className="col-lg-6">
                <h3 className="mb-3">Reference 2</h3>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Name</h6>

                  <b>{member && member[0] && member[0].reference_name_two || ""}</b>
                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Position</h6>
                  <b>{member && member[0] && member[0].reference_position_two || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Contact Number</h6>
                  <b>{member && member[0] && member[0].reference_phonenumber_two || ""}</b>

                </div>

                <div className="row mb-4">
                  <h6 className="text-secondary m-0">Email Address</h6>
                  <b>{member && member[0] && member[0].reference_email_two || ""}</b>
                  {/* <b>{member[0].reference_email_two || ""}</b> */}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default JobMemberDetail;
